import { NavLink, useParams } from "react-router-dom"
import useLabels from "../../hooks/useLabels"
import SecondaryBar from "../SecondaryBar"
import { CTA } from "../Generic"
import { selectConfigs, selectDrugs, selectUsers, selectWineMaking } from "../../context/selectors"
import { getDrugs, getProtocols, getUsers } from "../../services/utils"
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { lazy, Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux"
import { setDrugs } from "../../context/substances/drugsSlice";
import { ROLES } from "../../constants/base"
import useAuth from "../../hooks/useAuth"
// import WineMakingProtocolList from "../WineMakingProtocolList"
import { setWineMaking } from "../../context/protocols/wineMakingSlice"
import { setUsers } from "../../context/users/usersSlice"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { SkeletonTableEdit } from "../Skeleton/Skeleton"

const WineMakingProtocolList = lazy(() => import("../WineMakingProtocolList"));

const WineMakingProtocols = ({ isMobile }) => {
    const { type: rawType } = useParams();
    const type = rawType?.toUpperCase();
    const [getLabel] = useLabels();
    const protocols = useSelector(selectWineMaking);
    const substances = useSelector(selectDrugs);
    const users = useSelector(selectUsers);
    const configs = useSelector(selectConfigs);
    const axiosPrivate = useAxiosPrivate();
    const dispatch = useDispatch();
    const { auth } = useAuth();
    const role = auth?.role || ROLES.GUEST;
    
    const loadUsers = async () => {
      const currentUsers = await getUsers(axiosPrivate);
      dispatch(setUsers(currentUsers));
    }
  
    const loadSubstances = async () => {
        const currentSubstances = await getDrugs(axiosPrivate);
        dispatch(setDrugs(currentSubstances));
    }

    useEffect(() => {
        if (!protocols || protocols.length === 0) {
            loadProtocols()
        }
        if (!substances || substances.length === 0) {
            loadSubstances()
        }
        if (!users || users.length === 0) {
            loadUsers();
          }
    }, []);

    const loadProtocols = async () => {
        const currentProtocols = await getProtocols('winemaking', axiosPrivate) || [];
        dispatch(setWineMaking(currentProtocols));
    }

    const renderNavMenu = () => {
        return (
            <div className="primary_container_menu">
                <h2>{getLabel('protocols')}</h2>
                {role === ROLES.CLIENT && <NavLink to={`/protocols/winemaking/${type}/new`}>
                    <CTA customClassName={'create'}>
                        {type === 'PHYSICAL' ? getLabel('createWineMakingPhysicalProtocol') : type === 'PRE' ? getLabel('createWineMakingProtocol') 
                            : type === 'POST' ? getLabel('createWineMakingPostProtocol')
                            : getLabel('createWineMakingCIPProtocol')}
                        {" "}<FontAwesomeIcon icon="fa-plus" />
                    </CTA>
                </NavLink>}
            </div>
        )
    }

    return (<div className="primary_container">
        <SecondaryBar
            breadCrumb={[
                type === 'PHYSICAL' ? getLabel('wineMakingPhysicalProtocolsNavLink') 
                : type === 'PRE' ? getLabel('wineMakingProtocolsNavLink') 
                : type === 'POST' ? getLabel('wineMakingPostProtocolsNavLink')
                : getLabel('wineMakingCIPProtocolsNavLink')
            ]}
            isBasePathNeeded={false}
        />
        {renderNavMenu()}
        <Suspense fallback={<SkeletonTableEdit colCount={6} />}>
        <WineMakingProtocolList type={type} protocols={protocols?.filter((p) => p?.protocol_type === type)} users={users} configs={configs} isMobile={isMobile} />
        </Suspense>
    </div>)
}

export default WineMakingProtocols